import { BrowserRouter, Route, Routes } from "react-router-dom";
import CustomHeader from "../common/CustomHeader/CustomHeader";

import UploadLicensePage from "../views/UploadLicensePage"
import ManageLicensePage from "../views/ManageLicensePage";
import LicenseDetailsPage from "../views/LicenseDetailsPage";
import ManageOrdersPage from "../views/ManageOrdersPage";
import DownloadedOrdersPage from "views/DownloadedOrders";
import ContentBackfillPage from "views/ContentBackfillPage";

import Paths from "../common/paths/paths";
import UploadOrdersPage from "views/UploadOrdersPage";
import OrdersUploadedPage from "views/OrdersUploadedPage";
import BulkOrdersPage from "views/BulkOrdersPage";
import BulkOrdersTemplatesPage from "views/BulkOrdersTemplatesPage";
import ProductInventoryPage from "views/ProductInventoryPage";
import POConfigurationPage from "views/POConfigurationPage";
import ResellerReportHistoryPage from "views/ResellerReportHistoryPage";
import { PERMISSIONS } from "configuration/config";
import { UserPermissions } from "services/user-permissions";

const AdminRoutes = () => {
    const hasGspTracker = UserPermissions.instance.hasAuthorized && UserPermissions.instance.hasPermission(PERMISSIONS.TOGGLE_GSP_TRACKER);

    return (
    <BrowserRouter>
        <CustomHeader />
        <Routes>
            <Route path={Paths.uploadLicense.url} element={<UploadLicensePage />} />
            <Route path={Paths.manageLicense.url} element={<ManageLicensePage />} />
            <Route path={Paths.manageOrders.url} element={<ManageOrdersPage />} />
            <Route path={Paths.licenseDetails.url} element={<LicenseDetailsPage/>} />
            <Route path={Paths.uploadOrders.url} element={<UploadOrdersPage />} />
            <Route path={Paths.ordersUploaded.url} element={<OrdersUploadedPage />} />
            <Route path={Paths.ordersDownloaded.url} element={<DownloadedOrdersPage />} />
            {hasGspTracker && <Route path={Paths.bulkOrdersTemplates.url} element={<BulkOrdersTemplatesPage />} />}
            {hasGspTracker && <Route path={Paths.bulkOrders.url} element={<BulkOrdersPage />} />}
            {hasGspTracker && <Route path={Paths.productInventory.url} element={<ProductInventoryPage />} />}
            {hasGspTracker && <Route path={Paths.poConfiguration.url} element={<POConfigurationPage />} />}
            {hasGspTracker && <Route path={Paths.resellerReportHistory.url} element={<ResellerReportHistoryPage />} />}
            <Route path={Paths.contentBackfill.url} element={<ContentBackfillPage />} />
            <Route path="/*" element={<ManageOrdersPage />} />
        </Routes>
    </BrowserRouter>
    );
};

export default AdminRoutes;
